import apiHandler from '../../utilities/apiHandler.js';

const SellerReturnsApiHandler = {
	
	getAllFacilities: function () {
        return apiHandler.get("space/facility?status=true");
    },

    generateChallanForFacility: function(fcId) {
    	return apiHandler.get("seller_return/seller_return_documents_for_trip/get/"+fcId);
    },

    getGeneratedNotes: function(timestamp) {
    	return apiHandler.get("seller_return/seller_return_documents/get/"+timestamp);
    }
}

export default SellerReturnsApiHandler;


// WEBPACK FOOTER //
// ./src/screens/SellerReturns/SellerReturnsApiHandler.js